import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import cls from 'classnames';
function Icon(props) {
    const { className, name, ...rest } = props;
    return _jsx("span", { className: cls('cw-icon', `cw-icon-${name}`, className), ...rest });
}
export default memo(Icon);
